export default __webpack_public_path__ + "static/media/process_07.6f2a4925.png";